import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IFontProps {
  opacityValue?: string;
  rotationValue?: string;
  shapeType?: string;
  maxHeightValue?: string;
}

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 10px 10px 10px;
  box-sizing: border-box;
`;

export const HelpText = styled.div`
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
  padding: 0px 0px 5px 0px;
`;


export const ShapesContainer = styled.div`
  display:flex;
  flex-wrap:wrap;
`;

export const ShapeContainer = styled.div`
   padding: 7px;   
`;

export const ShapeVerticalContainer = styled.div`
   padding: 14px;   
`;

export const ImgShape = styled.img`
   max-width: 100%;
   max-height: 100%;
   object-fit: contain;
`;



export const DragShapeContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color:transparent;  
  transform: translate(0, 0);
  padding:2px;
  cursor:pointer;
`;
